import React from 'react';
import MotorcycleMenu from './MotorcycleMenu';
import { RouteComponentProps } from 'react-router-dom';
import { withStyles, WithStyles, Theme } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import Action from '../../../redux/reducers/models/action';
import Models from './Models';
import { CircularProgress } from '@material-ui/core';
import { StateManagementProps, mapStateToProps, mapDispatchToProps } from '../../../utils/addReduxProps';
import getModels from '../../../redux/async-actions/getModels';
import store from '../../../redux/store';
import { withNamespaces, WithNamespaces } from 'react-i18next';

export interface MotorcycleModelResponse {
	Segments: SegmentData[];
	ShowPricesInConfigurator: boolean;
}

export interface SegmentData {
	Name: string;
	Hero: Hero;
	Vehicles: VehicleInformation[];
}

export interface VehicleInformation {
	Name: string;
	ModelId: string;
	EngineType: string | null;
	Hero: Hero;
}

export interface Hero {
	Intro: string;
	Title: string;
	ImageUrl: string;
	Description: string;
	Price: Price;
}

export type Price = PriceWithValue | null;

export interface PriceWithValue {
	CurrencySymbol: string;
	Value: number;
}

export interface MotorcyclesProps {
	getMotorcycleModels: MotorcycleModelResponse;
	addMotorcycleModels: (payload: MotorcycleModelResponse) => Action;
}

export interface MotorcycleState {
	link: string;
	loaded: boolean;
}


export const classes: (theme: Theme) => Record<string, CSSProperties> = (theme) => ({
	motorcycles: {
		height: 'calc(100% - 76px)',
		boxSizing: 'border-box',
	},
	wrapper: {
		borderBottom: '1px solid #eee',
		padding: '0 10px 0 10px',
		maxWidth: 800,
	},
	alignCenter: {
		margin: '20px auto',
		fontSize: '1.3em',
	}
});

export type MotorcycleViewAllProps = MotorcyclesProps & RouteComponentProps<any> & WithStyles & WithNamespaces & StateManagementProps;

export class Motorcycles extends React.Component<MotorcycleViewAllProps, MotorcycleState> {

	constructor(props: MotorcycleViewAllProps) {
		super(props);
		this.state = { link: '', loaded: false };
		this.updateState = this.updateState.bind(this);
	}

	updateState(link: string) {
		this.setState({ link });
	}

	componentDidMount() {
		if (!this.hasModelData()) {
			store.dispatch((getModels() as any)).then(() => this.setState({ loaded: true }));
		} else {
			this.setState({ loaded: true });
		}
	}

	render() {
		if (!this.hasModelData() && !this.state.loaded) {
			return <CircularProgress className="spinner" />;
		}
		if (!this.hasModelData() && this.state.loaded) {
			return <p id="no-models" className={this.props.classes.alignCenter}>{this.props.t('motorcycles.notAvailable')}</p>;
		}
		const { Segments } = this.props.models;
		const links = Segments.map((segment: SegmentData) => segment.Name);
		const selectedSegment = this.state.link || links[0];
		const menuProps = {
			updateState: this.updateState,
			links,
			link: selectedSegment,
		};

		const { motorcycles } = this.props.classes;
		const segmentData: SegmentData = Segments.find((segment: SegmentData) => segment.Name === selectedSegment) as SegmentData;

		return (
			<section id="motorcycles" className={`${motorcycles} full-height`}>
				<MotorcycleMenu {...menuProps}></MotorcycleMenu>
				<Models data={segmentData} />
			</section>
		)
	}

	private hasModelData = () => !!this.props.models.Segments.length;
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(classes)(withNamespaces()(Motorcycles)));
